/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_TownhouseInputs */

const en_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Townhouse`)
};

const es_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adosado`)
};

const fr_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maison de ville`)
};

const de_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenhaus`)
};

const ja_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タウンハウス`)
};

const zh_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联排别墅`)
};

const ar_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاون هاوس`)
};

const id_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rumah Bandar`)
};

const it_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villetta a Schiera`)
};

const ru_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таунхаус`)
};

const pt_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrado`)
};

const ko_val_townhouse = /** @type {(inputs: Val_TownhouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타운하우스`)
};

/**
* | output |
* | --- |
* | "Townhouse" |
*
* @param {Val_TownhouseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_townhouse = /** @type {((inputs?: Val_TownhouseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_TownhouseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_townhouse(inputs)
	if (locale === "es") return es_val_townhouse(inputs)
	if (locale === "fr") return fr_val_townhouse(inputs)
	if (locale === "de") return de_val_townhouse(inputs)
	if (locale === "ja") return ja_val_townhouse(inputs)
	if (locale === "zh") return zh_val_townhouse(inputs)
	if (locale === "ar") return ar_val_townhouse(inputs)
	if (locale === "id") return id_val_townhouse(inputs)
	if (locale === "it") return it_val_townhouse(inputs)
	if (locale === "ru") return ru_val_townhouse(inputs)
	if (locale === "pt") return pt_val_townhouse(inputs)
	return ko_val_townhouse(inputs)
});